module.exports = __webpack_public_path__ + "static/media/js.c23dcc5c.png";